import * as React from 'react';
import { ILink } from '../login-page/login-page-links';
import * as styles from './footer.css';

interface IFooterProps {
  links: ILink[];
  disableGsLogoClick: boolean;
}

export const Footer: React.FC<React.PropsWithChildren<IFooterProps>> = props => {
  const { links } = props;
  return (
    <div className={styles.footer} id="login-footer">
      <div className={styles.logo} id="login-footer-gs-logo">
        {props.disableGsLogoClick ? (
          <img src="/resources/gs-black.svg" />
        ) : (
          <a href="https://www.gs.com" target="_blank" rel="noreferrer">
            <img src="/resources/gs-black.svg" />
          </a>
        )}
      </div>

      <div className={`grd-row ${styles.row}`} id="login-footer-links">
        {links.map(i => (
          <div className={styles.item} key={i.title}>
            <a href={i.url} target="_blank" rel="noreferrer">
              {i.title}
            </a>
          </div>
        ))}
      </div>

      <div className={`grd-row ${styles.row}`}>
        <h6>
          Copyright &copy;
          {new Date().getFullYear()} - Goldman Sachs
        </h6>
      </div>
    </div>
  );
};
